import { render, staticRenderFns } from "./DescargoEstPage.vue?vue&type=template&id=4d8ff0d4"
import script from "./DescargoEstPage.js?vue&type=script&lang=js&external"
export * from "./DescargoEstPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports